import { cn } from '@/lib/utils'
import { Tags } from 'lucide-react'
import type { ComponentProps, ReactElement } from 'react'

export function PriceChangeInlineHint({
  children,
  className = '',
  ...props
}: ComponentProps<'div'>): ReactElement {
  return (
    <div
      role="status"
      className={cn(
        'inline-flex items-start gap-1.5 text-sm leading-5 text-status-info-foreground',
        className
      )}
      {...props}
    >
      <Tags className="mt-0.5 size-3.5 shrink-0 text-status-info-foreground" />
      <div className="min-w-0">{children}</div>
    </div>
  )
}
